import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss']
})
export class CountdownComponent implements OnInit {


  public totalMinutes: number = 0; 
  public thisTime = new Date()
  public endTime: Date = new Date()
  public hours: number = 0;
  public minutes: number = 0;
  public seconds: number = 0;
  private interval: any;  

  @Input() eventTimeStartSell: any = "0"
  @Input() eventDateStartSell: any = "0"
  @Output() sendOpenEvent: EventEmitter<string> =  new EventEmitter()

  constructor() { }
 
   ngOnInit(): void {
    
    let time = (this.transformInDate(this.eventTimeStartSell, this.eventDateStartSell).getTime() - new Date().getTime())
    this.totalMinutes = time  / 1000 / 60;
    if (this.totalMinutes <= 0) {
     this.sendOpenEvent.emit("open")
    }

     this.changeTime(); 
     this.startCountdown();
    
   }
 
   ngOnDestroy(): void {
     if (this.interval) {
       clearInterval(this.interval);
     }
   }

  startCountdown() {
    this.interval = setInterval(() => {
      if (this.totalMinutes > 0 && Number.isNaN(this.seconds) == false) {
        this.totalMinutes --;
        this.changeTime();
      } 

      if (this.totalMinutes <= 0)  {
        this.sendOpenEvent.emit("open")
        clearInterval(this.interval);
      }
    }, 1000);
  }
  
   transformInDate(time: string, date: string){
      let now = new Date(date)
      let timeSplit = time.split(":");   
      now.setHours(Number(timeSplit[0]), Number( timeSplit[1]), 0, 0); 
      now.setDate(date.split("-")[2] as unknown as number)
      now.setMonth(date.split("-")[1] as unknown as number - 1)
      now.setFullYear(date.split("-")[0] as unknown as number)      
      return now
   }
 
   add0(time) {
    if (time < 10) {
      return '0' + time
    }
    return time.toString();
  }
 
   changeTime() {
    let time = (this.transformInDate(this.eventTimeStartSell, this.eventDateStartSell).getTime() - new Date().getTime())
    this.totalMinutes = time  / 1000 / 60;
    

    this.hours = this.add0(Math.floor(this.totalMinutes / 60)); 
    this.minutes = this.add0(Math.floor(this.totalMinutes % 60));
    this.seconds = this.add0(Math.floor((this.totalMinutes * 60) % 60)); 
   }
}
